import { handleActions } from 'redux-actions'
import { selectorForSlice } from 'lp-redux-utils'
import { handleSuccess } from 'lp-redux-api'

import * as apiActions from 'api-actions'
import { formatOrderStatusGrouped, snakeToKebab } from 'utils'
import {
  MANAGER_WORK_ORDER_LIST_LABELS,
  MANAGER_WORK_ORDER_STATUS_LABELS,
  ORDER_TYPE_LABELS_BY_ORDER_TYPE_MAP,
} from './constants'

const reducerKey = 'manager'
const slice = 'root.manager'

const initialState = {}

const reducer = handleActions(
  {
    [apiActions.fetchManagerWorkOrderLists]: handleSuccess(storeWorkOrders),
    [apiActions.fetchManagerWorkOrders]: handleSuccess(storeAllWorkOrders),
  },
  initialState
)

function storeWorkOrders(state, { payload }) {
  return {
    ...state,
    workOrders: payload.data ?? [],
  }
}

function storeAllWorkOrders(state, { payload }) {
  return {
    ...state,
    allWorkOrders: payload.data ?? [],
  }
}

const select = selectorForSlice(slice)

function pickRow(workOrder) {
  return {
    id: workOrder.id,
    name: workOrder.name,
    location: workOrder.location?.name,
    city: workOrder.location?.cityC,
    mostRecentAssignedDateTime: workOrder.mostRecentAssignedDateTime,
    agingAsp: workOrder.agingAsp,
    agingRni: workOrder.agingRni,
    workCompleteDateTime: workOrder.workCompleteDateTime,
    etaDate: workOrder.etaDate,
    orderStatusGrouped: formatOrderStatusGrouped(workOrder),
    orderType: workOrder.orderType,
  }
}

function workOrdersBySection(state, targetSectionId) {
  const workOrders = select('workOrders')(state) ?? []

  return workOrders
    .filter((workOrder) => {
      const kebabListIds = (workOrder.lists ?? []).map(snakeToKebab)
      return kebabListIds.includes(targetSectionId)
    })
    .map(pickRow)
}

// Build the row used by the index table. The Status column is sourced from
// the work order's raw `orderStatus`; the List column is sourced from the first
// manager list the WO belongs to (null when none, rendered as the column's
// fallback).
function pickIndexRow(workOrder) {
  const lists = workOrder.lists ?? []
  const firstListCategory = lists[0] ?? null
  const orderStatus = workOrder.orderStatus ?? null

  return {
    id: workOrder.id,
    date: workOrder.scheduledServiceDueDate,
    name: workOrder.name,
    location: workOrder.location?.name,
    city: workOrder.location?.cityC,
    orderType:
      ORDER_TYPE_LABELS_BY_ORDER_TYPE_MAP[workOrder.orderType] ??
      workOrder.orderType,
    status: orderStatus
      ? MANAGER_WORK_ORDER_STATUS_LABELS[orderStatus] ?? orderStatus
      : null,
    statusKey: orderStatus,
    list: firstListCategory
      ? MANAGER_WORK_ORDER_LIST_LABELS[firstListCategory] ?? firstListCategory
      : null,
    listKey: firstListCategory,
  }
}

function allWorkOrdersAsIndexRows(state) {
  const workOrders = select('allWorkOrders')(state) ?? []
  return workOrders.map(pickIndexRow)
}

const selectors = {
  workOrders: select('workOrders'),
  allWorkOrders: select('allWorkOrders'),
  workOrdersBySection,
  allWorkOrdersAsIndexRows,
}

export { reducer, selectors, reducerKey }
